// import React, { useState, useEffect } from 'react';
// import { TextField, Box, Grid, Button, Typography } from '@mui/material';
// import ValidationFunctions from '../../utils/ValidationFunctions';
// import { useDispatch, useSelector } from 'react-redux';
// import * as registerActions from '../../core/Store/Actions/RegisterActions';
// import Loader from '../../components/loader';
// import { Link, useNavigate } from 'react-router-dom';
// import { makeStyles } from '@mui/styles';
// import { lobbyImg } from '../../assets';
// import { VscDeviceCameraVideo } from 'react-icons/vsc'
// //import { formatPhoneNumber } from '../utils/globalFunctions';

// const useStyles = makeStyles(theme => ({
//     circle: {
//         width: '108px',
//         height: '108px',
//         top: '95px',
//         left: '1000px',
//         borderRadius: '50%',
//         //position: 'absolute',
//         backgroundColor: '#007AFF1A',
//         display: 'flex',
//         justifyContent: 'center',
//         alignContent: 'center',
//         //alignItems:'center'
//     },

//     /*videoCallIcon: {
//         width: '30px',
//         height: '28px',
//         top: '10px',
//         left: '2px',
//         position: 'absolute'
//     }*/

//     joinButton: {
//         height: '59px',
//         width: '192.9791717529297px',
//         //left: '846px',
//         //top: '497px',
//         borderRadius: '6.1458330154418945px',
//         background: '#28C151',
//         marginRight:10
//     }
// }));

// const LobbyScreen = () => {
//     const classes = useStyles();

//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     return (

//         <div style={{ height: "100vh" }}>
//             <Box sx={{ flexGrow: 1 }} style={{ height: "100vh" }}>
//                 <Grid container columns={16} style={{ height: "inherit", overflow: 'hidden' }}>
//                     <Grid item xs={8} style={{ background: "black", overflowY: 'hidden' }}>

//                         <div style={{ position: "relative" }}>
//                             <div style={{ height: "100vh" }}>
//                                 <img src={lobbyImg} alt="lobbyImg" width="100%" height="100%" />
//                             </div>

//                             <div style={{
//                                 position: 'absolute',
//                                 bottom: '88px',
//                                 left: '122px',
//                                 flexDirection: 'row'
//                             }}>
//                                 <Typography style={{ color: '#FFFFFF' }}><a>{`1.844.900.AKOS(2567)`}</a><span style={{
//                                     paddingLeft: 20,
//                                     paddingRight: 20
//                                 }}>|</span><a>info@akosmd.com</a></Typography>

//                             </div>
//                         </div>
//                     </Grid>

//                     <Grid item xs={8} style={{ background: "white", overflowY: 'auto', height: '100%', padding: '100px' }}>
//                         <Grid style={{
//                             //alignItems: 'center',
//                             flexDirection: 'column',
//                             display: 'flex'
//                         }}>

//                             <Grid className='App'>
//                                 <Grid>

//                                     <div className={classes.circle}>
//                                         <VscDeviceCameraVideo color='#024C9C' size={50} style={{ alignSelf: 'center' }} />
//                                     </div>

//                                     <div>
//                                         <Box style={{ margin: "40px" }}>
//                                             <h2>Welcome to the virtual waiting room</h2>
//                                             <p>You have been checked in to the Akos Virtual waiting room.</p>
//                                             <p>Please wait, we will be in touch shortly.</p>
//                                         </Box>

//                                         <Button size='large' color='success' className={classes.joinButton} onClick={(e) => { e.preventDefault(); navigate('/room/livecall') }}>Join</Button>
//                                         {/* <div style={{width:'5%'}}></div> */}
//                                         <Button  size='large' color='error' className={classes.joinButton} onClick={(e)=>{e.preventDefault();navigate('/room/medical')}}>Leave</Button>

//                                         <p>Download our app on Google Play Store and App Store</p>
//                                     </div>
//                                 </Grid>
//                             </Grid>

//                             {/* {loading && <Loader />} */}
//                         </Grid>

//                     </Grid>
//                 </Grid>
//             </Box>
//         </div>

//     );
// }
// export default LobbyScreen;

import React, { useState, useEffect } from 'react';
import { TextField, Box, Grid, Button, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { AiOutlineLeft } from "react-icons/ai";
import ValidationFunctions from '../../utils/ValidationFunctions';
import { useDispatch, useSelector } from 'react-redux';
import * as registerActions from '../../core/Store/Actions/RegisterActions';
import Loader from '../../components/loader';
import { Link, useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { mainImage, appStoreImg, playStoreImg } from '../../assets';
import { VscDeviceCameraVideo } from 'react-icons/vsc'
//import { formatPhoneNumber } from '../utils/globalFunctions';

const useStyles = makeStyles(theme => ({
    circle: {
        width: '108px',
        height: '108px',
        top: '95px',
        left: '1000px',
        borderRadius: '50%',
        //position: 'absolute',
        backgroundColor: '#007AFF1A',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        //alignItems:'center'
    },

    /*videoCallIcon: {
        width: '30px',
        height: '28px',
        top: '10px',
        left: '2px',
        position: 'absolute'
    }*/

    joinButton: {
        height: '59px',
        width: '192.9791717529297px',
        //left: '846px',
        //top: '497px',
        borderRadius: '6.1458330154418945px',
        background: '#28C151',
        marginRight: 10
    }
}));

const LobbyScreen = () => {
    const classes = useStyles();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const handleClose = () => {
        setShowAlert(false);
    }
    const renderConfirmEndCall = () => (
        <Dialog
            open={showAlert}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Confirm End Call</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Do you really want to end this call?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => {
                    e.preventDefault();
                    navigate('/');
                }} color="primary">
                    Yes
            </Button>
                <Button onClick={handleClose} color="primary" autoFocus>
                    No
            </Button>
            </DialogActions>
        </Dialog>
    );
    // window.onpopstate = () => {
    //     if ('http://localhost:3000/room/preview' === 'http://localhost:3000/room/preview') {
    //         setShowAlert(true);
    //         navigate('/room/preview');
    //     }
    // }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div style={{ height: "100vh", padding: '10% 10%' }}>
            <Box >
                <Grid container>
                    <div style={{
                        width: "100%",
                        backgroundColor: "white",
                        //height: "100%",
                        display: "flex",
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>
                        <div className={classes.circle} style={{
                            marginTop: -18,
                        }}>
                            <VscDeviceCameraVideo color='#024C9C' size={'45%'} style={{ alignSelf: 'center' }} />
                        </div>
                        <Button style={{
                            fontFamily: 'Manrope',
                            fontStyle: "normal",
                            fontWeight: 600,
                            fontSize: 24,
                            display: "flex",
                            alignItems: "center",
                            color: "#024C9C",
                            textDecoration: "none",
                        }} onClick={(e) => { e.preventDefault(); navigate('/room/symptoms') }}>
                            <AiOutlineLeft />Back</Button>
                    </div>
                    {/* <Grid>
                        <Typography style={{
                            textAlign: "left",
                            fontFamily: 'Manrope',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            fontSize: 28,
                            display: "flex",
                            justifyContent: "space-between",
                            color: "#000000",
                        }} >
                            <a href="" className={classes.backArrow} onClick={() => navigate('/room/patient')}>
                                <AiOutlineLeft />Back</a>
                        </Typography>
                    </Grid> */}
                </Grid>
                {renderConfirmEndCall()}

                <Grid style={{ marginTop: "10%" }}>
                    <Grid>
                        <div>
                            <Box style={{ marginBottom: '10%' }}>
                                <h2 className='lobyh2'>Welcome to the virtual waiting room</h2>
                                <p className='lobyP'>{`You have been checked in to the Akos MD virtual waiting room.\nPlease wait and a member of our clinical team will be with you shortly.`}</p>
                                {/* <p className='lobyP'>Please wait, we will be in touch shortly.</p> */}
                            </Box>
                            <Grid container style={{ justifyContent: 'space-between', width: '60%',}}>
                                <Button style={{ backgroundColor: '#28C151', borderRadius: '7px',fontFamily:'manrope' }} size='large' variant="contained" color='success' className="lobyJoinButton" onClick={(e) => { e.preventDefault(); navigate('/room/livecall') }}>Join</Button>
                                <Button style={{ backgroundColor: '#F50058', borderRadius: '7px',fontFamily:'manrope' }} size='large' color='error' variant="contained" className="lobyLeaveButton" onClick={() => { setShowAlert(true) }}>Leave</Button>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
                <div style={{
                    position: 'absolute',
                    top: '65%',
                    //left: '0',
                    //right: '5%'
                }}>
                    <div style={{ display: 'flex' }}>
                        <Typography style={{
                            fontSize: '28px', color: '#000000', fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '700',
                        }}>Download AkosMD App </Typography>
                    </div>
                    <div style={{ display: 'flex', width: '80%', justifyContent: 'space-between', marginTop: '10%' }}>
                        <img src={appStoreImg} style={{ cursor: 'pointer', width: '45%' }} onClick={(e) => { e.preventDefault(); window.location.href = 'https://apps.apple.com/us/app/akos/id1187895369' }} //{() => window.open('https://apps.apple.com/us/app/akos/id1187895369')} 
                        />
                        <img src={playStoreImg} style={{ cursor: 'pointer', width: '45%' }} onClick={(e) => { e.preventDefault(); window.location.href = 'https://play.google.com/store/apps/details?id=com.akosmd.patientapp&hl=en_IN&gl=US&pli=1' }} />
                    </div>
                </div>
            </Box>
        </div>
    );
}
export default LobbyScreen;